export default __webpack_public_path__ + "pdfs/SMP-guide.pdf";